import { render, staticRenderFns } from "./StudioProductCheckoutPayPalConfirm.vue?vue&type=template&id=70193528&scoped=true&"
import script from "./StudioProductCheckoutPayPalConfirm.vue?vue&type=script&lang=js&"
export * from "./StudioProductCheckoutPayPalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductCheckoutPayPalConfirm.vue?vue&type=style&index=0&id=70193528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70193528",
  null
  
)

export default component.exports